var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":"","target":"_blank","href":_vm.gameLink(_vm.item)}},[_c('v-icon',{attrs:{"color":"green lighten-2"}},[_vm._v("fa-gamepad")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }